import { Button, Card, CardContent } from "@mui/material";
import AppTable from "components/AppTable/AppTable";
import { toDate } from "helpers/dateHelper";
import { toCurrencyFormat } from "helpers/utils";
import { useGetReturnDetails } from "hooks/useGetReturnDetails";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import returnsService from "services/admin/returnsService";

export const ReturnDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { data, isLoading, error } = useGetReturnDetails(id);
  if (isLoading) return <div>Загрузка...</div>;
  if (error) return <div>Error: {error.message}</div>;

  const acceptReturn = () => {
    console.log("acceptReturn");
  };

  const rejectReturn = () => {
    console.log("rejectReturn");
  };

  /**
   * Возврат денежных средств покупателю
   * ТОЛЬКО ДЛЯ РАЗРАБОТКИ
   * В реальной системе этот метод не нужен
   * @returns
   */
  const refundCustomer = async () => {
    console.log("refundCustomer");
    const isConfirmed = window.confirm("Вы точно хотите вернуть денежные средства покупателю?");
    if (!isConfirmed) {
      return;
    }
    try {
      const { data } = await returnsService.refund(Number(id));
      toast.success(data.message);      
    } catch (error: any) {
      console.error("refundCustomer error:", error);
      toast.error(`Во время возврата денежных средств покупателю вышла ошибка: ${error?.message}`);
    }
  };

  const buttons = () => {
    return (
      <div className="flex gap-16">
        <Button variant="contained" color="primary" onClick={acceptReturn}>
          Принять возврат
        </Button>
        <Button variant="outlined" color="error" onClick={rejectReturn}>
          Отклонить возврат
        </Button>
        <Button variant="outlined" color="primary" onClick={refundCustomer}>
          Возврат денежных средств покупателю
        </Button>
      </div>
    );
  };

  return (
    <div>
      <section className="m-b-32">
        <h3 className="m-b-16">Детали возврата</h3>
        <Card>
          <CardContent>
            <div className="m-b-8">
              <strong>ID: </strong>
              {data.id}
            </div>
            <div className="m-b-8">
              <strong>Дата создания: </strong>
              {toDate(data.createdAt)}
            </div>
            <div className="m-b-8">
              <strong>Статус доставки: </strong>
              {data.shipmentStatus}
            </div>
            <div className="m-b-8">
              <strong>Статус возврата: </strong>
              {t(`REFUND_STATUS.${data.refundStatus}`)}
            </div>
            <div>
              <strong>Связанный заказ: </strong>
              <Link
                className="color-blue"
                to={`/admin/products/sub-orders/view/${data.subOrderID}`}
              >
                {data.subOrderID}
              </Link>
            </div>
          </CardContent>
        </Card>
      </section>
      <div className="m-b-32">
        <h3 className="m-b-8">Товары</h3>
        <AppTable
          id="return-items-table"
          columnConfig={[
            {
              key: "image",
              label: "Изображение",
              render: (item: any) => (
                <img src={item.image} alt={item.name} style={{ width: 50, objectFit: "cover" }} />
              ),
            },
            {
              key: "name",
              label: "Название",
            },
            {
              key: "quantity",
              label: "Количество",
            },
            {
              key: "price",
              label: "Цена",
              render: (item: any) => toCurrencyFormat(item.price, item.currency),
            },
            {
              key: "reasonType",
              label: "Причина возврата",
              render: (item: any) => item.reasonType,
            },
            {
              key: "comment",
              label: "Комментарий",
              render: (item: any) => item.comment,
            },
          ]}
          data={data.returnItems}
          loading={isLoading}
          onDelete={() => {}}
        />
      </div>
      <div className="m-b-16">
        <h3 className="m-b-8">Покупатель</h3>
        <Card>
          <CardContent>
            <div>
              {data.user?.lastName} {data.user?.firstName}
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="m-b-8">{buttons()}</div>
    </div>
  );
};
